import api from '../../lib/api';
import { Role, RolePayload, RolesResponse, RoleFilters } from './types';

export const fetchRoles = async (params?: RoleFilters): Promise<RolesResponse> => {
  const { page = 1, pageSize = 200, sortBy = 'name', sortDir = 'asc', search = '' } = params || {};
  const { data } = await api.get<RolesResponse>('roles', { params: { page, pageSize, sortBy, sortDir, search } });
  return data;
};

export const createRole = async (payload: RolePayload): Promise<Role> => {
  const { data } = await api.post<Role>('roles', payload);
  return data;
};

export const updateRole = async (id: string, payload: RolePayload): Promise<Role> => {
  const { data } = await api.put<Role>(`roles/${id}`, payload);
  return data;
};

export const deleteRole = async (id: string): Promise<void> => {
  await api.delete(`roles/${id}`);
};

